import DropdownToggle from "react-bootstrap/DropdownToggle";
import styled from "@emotion/styled";

import styledConst from "styles";

const CustomDropdownToggle = styled(DropdownToggle)`
    background-color: ${styledConst.Primary_Blue_3};
    border-color: ${styledConst.Primary_Blue_3};

    &::after {
        display: none;
    }

    &.btn-primary {
        &.dropdown-toggle,
        &.dropdown-toggle:focus,
        &:not(:disabled):not(.disabled):active,
        &.dropdown-toggle:hover {
            background-color: ${styledConst.Primary_Blue_3};
            border-color: ${styledConst.Primary_Blue_3};
        }
    }

    .material-icons,
    .material-icons-outlined {
        color: ${styledConst.Primary_Green_1};
        vertical-align: middle;
    }

    .dot {
        height: 8px;
        width: 8px;
        background-color: ${styledConst.Primary_Green_1};
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
    }
`;

export default CustomDropdownToggle;
